module.exports = __webpack_public_path__ + "fonts/Manrope-500-latin12_e85a026.woff2";